import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import { alpha } from '@material-ui/core/styles';
import { getNicheVisualTheme, nicheSectionId } from './nicheVisualTheme';

/** Chips de color por vertical; opcional enlace a ancla en /programacion. */
const NicheColorLegend = ({
  niches,
  isDark = false,
  linkable = false,
  size = 'small',
  caption,
}) => (
  <Box>
    {caption ? (
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          textAlign: 'center',
          color: isDark ? 'rgba(255,255,255,0.65)' : 'text.secondary',
          mb: 1.25,
          fontWeight: 600,
          letterSpacing: 0.3,
        }}
      >
        {caption}
      </Typography>
    ) : null}
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
      {niches.map((niche) => {
        const t = getNicheVisualTheme(niche);
        const href = linkable ? `#niche-${nicheSectionId(niche)}` : undefined;
        const chipLabel = (
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            <Box
              component="span"
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: t.accent,
                flexShrink: 0,
                boxShadow: `0 0 0 2px ${alpha(t.main, 0.28)}`,
              }}
            />
            {niche}
          </Box>
        );
        return (
          <Chip
            key={niche}
            component={href ? 'a' : 'div'}
            href={href}
            clickable={Boolean(href)}
            label={chipLabel}
            size={size}
            sx={{
              fontWeight: 700,
              fontSize: size === 'small' ? '0.72rem' : '0.8rem',
              height: 'auto',
              py: 0.5,
              maxWidth: { xs: '100%', sm: 260 },
              bgcolor: isDark ? alpha(t.main, 0.32) : t.light,
              color: isDark ? '#fff' : t.main,
              border: `1px solid ${alpha(t.main, isDark ? 0.5 : 0.35)}`,
              boxShadow: isDark ? 'none' : `0 2px 8px ${alpha(t.main, 0.12)}`,
              '& .MuiChip-label': {
                whiteSpace: 'normal',
                lineHeight: 1.25,
              },
              ...(href
                ? {
                  textDecoration: 'none',
                  '&:hover': {
                    bgcolor: t.main,
                    color: '#fff',
                    borderColor: t.main,
                  },
                }
                : {}),
            }}
          />
        );
      })}
    </Box>
  </Box>
);

NicheColorLegend.propTypes = {
  niches: PropTypes.arrayOf(PropTypes.string).isRequired,
  isDark: PropTypes.bool,
  linkable: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  caption: PropTypes.string,
};

export default NicheColorLegend;
